"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ActionTypes = _interopRequireDefault(require("ComposeUI/redux/ActionTypes"));

var _constants = require("ComposeUI/lib/constants");

var _Modals = _interopRequireDefault(require("ComposeUI/data/model/Modals"));

var _default = function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _Modals.default();
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _ActionTypes.default.DISMISS_MODAL:
      return state.set('modalOpen', null);

    case _ActionTypes.default.SHOW_COMPOSE_EDIT_INTERSTITIAL_MODAL:
      return state.set('modalOpen', _constants.ModalNames.COMPOSE_EDIT_INTERSTITIAL);

    case _ActionTypes.default.SHOW_ONBOARDING_MODAL:
      return state.set('modalOpen', _constants.ModalNames.ONBOARDING);

    case _ActionTypes.default.SHOW_OPTOUT_TALLY:
      return state.set('showOptOutTally', true);

    default:
      return state;
  }
};

exports.default = _default;
module.exports = exports.default;